// @flow
import React from "react";
import { withDeposit } from "../common/withDeposit";
import Gettext from "../common/Gettext";
import Money from "../Money";
import Popup from "./Popup";
import dataLayer from "../common/dataLayer";

import {
  Title,
  Subtitle,
  InlineContainer,
  InlineBlock,
  ButtonDesc,
  Button
} from "./StyledComponents";

type Props = {
  onDismiss: () => void,
  onRefillDemoClick: () => Promise<*>,
  initialDeposit: number,
  minFillup: number,
  currency: string,
  isActiveAccountReal: boolean,
  showDeposit: boolean,
  profileId: string,
  style?: Object
};

type CustomGaProps = {
  screen: "demo" | "real",
  action: "refill" | "refillDemo" | "close",
  label?: string
};

class InsufficientPopup extends React.Component<Props, {}> {
  gaEvent = (props: CustomGaProps) => {
    const { screen, action } = props;
    const popup = "insuffient";
    const { profileId } = this.props;

    let { label } = props;
    if (!label) {
      switch (action) {
        case "refill":
          label = "Пополнение реального счета с";
          break;
        case "refillDemo":
          label = "Пополнение демо-счета с";
          break;
        default:
          label = "Закрытие";
          break;
      }
    }

    dataLayer({
      event: "event-to-ga",
      eventCategory: "Insufficient Popup",
      eventAction: `${popup}-${action}_screen-${screen}_profileId-${profileId}`,
      eventLabel: `${label} попапа "недостаточно средств", экран ${screen}`
    });
  };

  componentDidMount() {
    dataLayer({
      event: "for_ga-disp-popup-demorefill",
      eventCategory: "disp-popup-demorefill",
      eventAction: "cl_popup1_show"
    });
  }

  render() {
    const { isActiveAccountReal, onDismiss } = this.props;

    return (
      <Popup
        onDismiss={() => {
          this.gaEvent({
            screen: isActiveAccountReal ? "real" : "demo",
            action: "close"
          });
          onDismiss();
        }}
      >
        <Title>
          <Gettext>Insufficient funds on the account!</Gettext>
        </Title>

        <Subtitle>
          <Gettext>Top up your account to start trading</Gettext>
        </Subtitle>

        <InlineContainer>
          {!isActiveAccountReal && (
            <InlineBlock>
              <Button
                demo
                as="span"
                disabled={this.props.isFetching}
                onClick={() => {
                  this.props.onRefillDemoClick().then(() => {
                    dataLayer({
                      event: "for_ga-disp-popup-demorefill",
                      eventCategory: "disp-popup-demorefill",
                      eventAction: "cl_popup1_refill"
                    });
                    onDismiss();
                  });
                }}
              >
                <Gettext>Refill Demo</Gettext>
              </Button>
              <ButtonDesc>
                <Gettext>Free Refill demo account with</Gettext>{" "}
                <Money>{this.props.initialDeposit}</Money>
              </ButtonDesc>
            </InlineBlock>
          )}
          {this.props.showDeposit && (
            <InlineBlock>
              <Button
                onClick={() => {
                  dataLayer({
                    event: "for_ga-disp-popup-demorefill",
                    eventCategory: "disp-popup-demorefill",
                    eventAction: "cl_popup1_fillup"
                  });
                }}
                to="/fillup"
                green
                demo
              >
                <Gettext>Add Money</Gettext>
              </Button>
              <ButtonDesc>
                <Gettext>Minimum deposit is</Gettext>{" "}
                <Money>{this.props.minFillup}</Money>
              </ButtonDesc>
            </InlineBlock>
          )}
        </InlineContainer>
      </Popup>
    );
  }
}

export default withDeposit(InsufficientPopup);



// WEBPACK FOOTER //
// ./src/components/InsufficientPopup/InsufficientPopup.js